import React from 'react';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';

import { useStyles } from './ChartLegend.styles';

/**
 * @typedef {Object} ChartLegendProps
 * @property {string} mainColor
 * @property {string} mainTitle
 * @property {string} secondaryColor
 * @property {string} secondaryTitle
 */

/**
 * @param {ChartLegendProps} props
 */
export const ChartLegend = ({ mainColor, mainTitle, secondaryColor, secondaryTitle }) => {
  const styles = useStyles({
    mainColor,
    secondaryColor
  });
  return (
    <div aria-label="chart-legend" className={styles.flexAlignCenter}>
      <div className={styles.legendContainer}>
        <div className={clsx(styles.legendColor, styles.mainColor)} />
        <Typography>{mainTitle}</Typography>
      </div>

      <div className={styles.legendContainer}>
        <div className={clsx(styles.legendColor, styles.secondaryColor)} />
        <Typography>{secondaryTitle}</Typography>
      </div>
    </div>
  );
};
